<template>
  <div class="home-page home-page0">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img class="nav-icon-left" src="../../static/images/back.png" width="20"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="home-content mt50">
      <div class="content crfff ac por">
        <!-- 专题列表 -->
        <div class="land-content al">
          <div class="land-col">
            <div
              v-for="(item, index) in leftProducts"
              :key="item.id || 'l-' + index"
            >
              <div class="two" @click="goDetail(item.web_path)">
                <img
                  v-if="item.is_new"
                  style="position: absolute;right: 0px;top: -20px;width: 40%"
                  src="../../static/images/Festival_icon.png"
                />
                <div class="cover-wrap">
                  <img :src="item.image" loading="lazy" />
                  <template v-if="item.type === 'video'">
                    <div class="cover-tags-bar">
                      <span class="cover-tag cover-tag-left">
                        <img class="cover-tag-icon" src="../../static/images/camera.png" alt="" />
                        {{$t('Shoot_same_video')}}
                      </span>
                      <span v-if="item.video_time" class="cover-tag cover-tag-right">{{ item.video_time }}</span>
                    </div>
                  </template>
                  <div class="cover-title">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="land-col">
            <div
              v-for="(item, index) in rightProducts"
              :key="item.id || 'r-' + index"
            >
              <div class="two" @click="goDetail(item.web_path)">
                <img
                  v-if="item.is_new"
                  style="position: absolute;right: 0px;top: -20px;width: 40%"
                  src="../../static/images/Festival_icon.png"
                />
                <div class="cover-wrap">
                  <img :src="item.image" loading="lazy" />
                  <template v-if="item.type === 'video'">
                    <div class="cover-tags-bar">
                      <span class="cover-tag cover-tag-left">
                        <img class="cover-tag-icon" src="../../static/images/camera.png" alt="" />
                        {{$t('Shoot_same_video')}}
                      </span>
                      <span v-if="item.video_time" class="cover-tag cover-tag-right">{{ item.video_time }}</span>
                    </div>
                  </template>
                  <div class="cover-title">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div v-if="!hasMore && product.length > 0" class="fs26 ac cr999 mt20">{{ $t('No more') || '没有更多了' }}</div>-->
<!--        <div v-if="!tag" class="fs26 ac cr999 mt20">{{ $t('Need tag') || '请通过专题入口进入' }}</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      tag: '',
      tagTitle: '', // 可选：从接口或 query 的 title 展示
      product: [],
      currentPage: 1,
      pageLimit: 20,
      hasMore: true,
      isLoading: false
    }
  },
  computed: {
    leftProducts() {
      if (!Array.isArray(this.product)) return []
      return this.product.filter((_, idx) => idx % 2 === 0)
    },
    rightProducts() {
      if (!Array.isArray(this.product)) return []
      return this.product.filter((_, idx) => idx % 2 === 1)
    }
  },
  watch: {
    '$route.query.tag'(val) {
      this.tag = val || ''
      this.tagTitle = this.$route.query.title || val || ''
      this.getList(true)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.tag = this.$route.query.tag || ''
    this.tagTitle = this.$route.query.title || this.tag || ''
    this.getHome()
    if (this.tag) {
      this.getList(true)
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getHome() {
      const that = this
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function() {
          that.score = r.data.score
        })
      })
    },
    getList(reset = false) {
      const that = this
      if (!that.tag) return
      if (reset) {
        that.product = []
        that.currentPage = 1
        that.hasMore = true
      }
      if (that.isLoading || !that.hasMore) return
      that.isLoading = true
      const data = {
        tag: that.tag,
        page: that.currentPage,
        limit: that.pageLimit
      }
      that.$api.post('/api/product/tagList', data, r => {
        that.isLoading = false
        that.$parent.returnCode(r, function() {
          if (r.data && r.data.list) {
            that.product = that.product.concat(r.data.list)
            that.hasMore = r.data.hasMore || false
            that.currentPage += 1
          } else {
            if (Array.isArray(r.data)) {
              that.product = reset ? r.data : that.product.concat(r.data)
              that.hasMore = r.data.length >= that.pageLimit
              that.currentPage += 1
            }
          }
        })
      }, () => {
        that.isLoading = false
      })
    },
    goDetail(path) {
      this.$router.push({ path: path })
    },
    handleScroll() {
      if (this.isLoading || !this.hasMore || !this.tag) return
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const threshold = 200
      if (scrollTop + windowHeight >= documentHeight - threshold) {
        this.getList(false)
      }
    }
  }
}
</script>

<style scoped>
.topic-title {
  flex: 1;
  text-align: center;
  font-size: 0.32rem;
}
.chances-top {
  margin-bottom: 0.2rem;
}
/* 与首页一致的两列瀑布流 */
.land-content {
  display: flex;
  align-items: flex-start;
  column-count: 1;
  column-gap: 0;
  width: 100%;
}
.land-col {
  flex: 1;
}
.land-col:first-child {
  margin-right: 0.1rem;
}
.land-col .two {
  width: 100%;
  margin: 0 0 0.1rem 0;
}
.cover-wrap {
  position: relative;
  display: block;
  width: 100%;
  border-radius: 0.18rem;
  overflow: hidden;
}
.cover-wrap > img {
  display: block;
  width: 100%;
  border-radius: 0.18rem;
}
.cover-tags-bar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 0.1rem 0.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0));
}
.cover-tag {
  position: static;
  font-size: 0.22rem;
  color: #fff;
  padding: 0.04rem 0.1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0.08rem;
  display: inline-flex;
  align-items: center;
  line-height: 1.1;
}
.cover-tag-left .cover-tag-icon {
  width: 0.28rem;
  height: 0.28rem;
  margin-right: 0.06rem;
  flex-shrink: 0;
}
.cover-tag-left {}
.cover-tag-right {}

.cover-title {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 0.2rem;
  color: #fff;
  text-align: center;
  padding: 0.16rem 0.18rem 0.14rem;
  line-height: 1.2;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/page/topic.vue